import apiClient from '../utils/apiClient';

const calculation = '/calculation';

// Fetch all calculations
export const GetAllCalculations = async () => {
  try {
    const response = await apiClient.get(`${calculation}/GetAll`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all calculations:', error);
    return Promise.reject(error);
  }
};

// Fetch a calculation by ID
export const GetCalculationById = async id => {
  try {
    const response = await apiClient.get(`${calculation}`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching calculation with ID ${id}:`, error);
    return Promise.reject(error);
  }
};

// Create a new calculation
export const CreateCalculation = async calculationData => {
  try {
    const response = await apiClient.post(`${calculation}`, calculationData);
    return response.data;
  } catch (error) {
    console.error('Error creating calculation:', error);
    return Promise.reject(error);
  }
};

// Update an existing calculation
export const UpdateCalculation = async (id, calculationData) => {
  try {
    const response = await apiClient.put(`${calculation}`, calculationData, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating calculation with ID ${id}:`, error);
    return Promise.reject(error);
  }
};

// Delete a calculation
export const deleteCalculation = async id => {
  try {
    const response = await apiClient.delete(`${calculation}`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error(`Error deleting calculation with ID ${id}:`, error);
    return Promise.reject(error);
  }
};

// Alternative implementation for createCalculation
export const createCalculation = async data => {
  try {
    const response = await apiClient.post(`${calculation}`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating calculation:', error);
    return Promise.reject(error);
  }
};

// Alternative implementation for updateCalculation
export const updateCalculation = async (id, data) => {
  try {
    const response = await apiClient.put(`${calculation}?id=${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating calculation with ID ${id}:`, error);
    return Promise.reject(error);
  }
};
